// const pWin = window.opener
const cWins = []
const listeners = new Map()


const emit = (data) => {
  console.log('???eimit', data)
  data = JSON.parse(data)
  console.log('data', data)
  const label = data.label
  console.log(label, '???', data.label)
  const params = data.params
  let cuurentListeners = listeners.get(label)
  console.log('有emit', label)
  if (cuurentListeners && cuurentListeners.length) {
    cuurentListeners.forEach((listener) => {
      listener.callback.call(null,params)
    })
  }
}


const addListener = (label, callback) => {
  if (typeof callback === 'function') {
    listeners.has(label) || listeners.set(label, [])
    listeners.get(label).push({callback: callback})
    return true
  }
  return false
}
const removeListener = (label) => {
  if (listeners.has(label)) {
    listeners.delete(label)
  }
}
/*window.ToParentMessage = (data) => {
    if (pWin) {
        pWin.ToParentMessage(data)
    } else {
        console.log('只有父窗口')
        window.ToChildMessage(data)
        emit(data)
    }
}
window.ToChildMessage = (data) => {
    console.log('有子窗， 子窗口响应', data)
    cWins.map(function(elem) {
        elem.ToChildMessage(data)
    })
}
*/
// 注册storage事件
window.addEventListener("storage", (ev) => {
  if (ev.key == 'message') {
    // removeItem同样触发storage事件，此时ev.newValue为空
    if(!ev.newValue) {
        return;
    }
    console.log('收到消息？？？',ev , ev.newValue)
    emit(JSON.parse(ev.newValue))
  }
}, false)

const windowMessage = {
  open: (url) => {
    let cwin = window.open(url)
    cWins.push(cwin)
  }, 
  // 向应事件
  emit: (data) => {
    const message = JSON.stringify(data)
    window.localStorage.setItem('message',JSON.stringify(message));
    window.localStorage.removeItem('message');
    emit(message)
    // window.ToParentMessage(JSON.stringify(data))
  },
  //  注册事件
  on: addListener,
  // 解除事件
  off: removeListener
}

export default windowMessage